<template>
    <ValidationProvider
        :name="name"
        :rules="rules"
        :mode="mode"
        v-slot="{ errors }"
        class="flex flex-col"
    >
        <input
            :name="name"
            :type="type"
            class="bg-transparent border-b-2 border-blue-lightest pb-2 pl-1 font-secondary fomt-semibold text-gray-600 placeholder-gray-600 mb-1"
            :class="inputClass"
            :style="inputStyle"
            :placeholder="placeholder"
            :value="value"
            @input="$emit('input', $event.target.value)"
            :required="required"
        />

        <span
            class="font-secondary text-xs text-red-500"
            :style="{ minHeight: '36px' }"
            >{{ errors[0] }}</span
        >
    </ValidationProvider>
</template>

<script>
export default {
    name: "form-input",

    props: {
        name: {
            type: String,
            required: true
        },

        type: {
            type: String,
            default: "text"
        },

        value: {
            required: true,
            validator: prop => typeof prop === "string" || prop === null
        },

        placeholder: {
            type: String
        },

        required: {
            type: Boolean,
            default: false
        },

        rules: {
            type: String,
            default: ""
        },

        mode: {
            type: String,
            default: "lazy"
        },

        inputClass: {
            type: String,
            default: ""
        },

        inputStyle: {
            type: Object,
            default: () => {}
        }
    }
};
</script>
